export const bulkFooterSortedBtns = (arr, isEOCampaign = false) => {
  // Default order for non-EO campaigns
  const defaultBtnOrder = ['approve', 'reject', 'consult'];
  // Order for EO campaigns
  const eoBtnOrder = [
    'approve',
    'belongsToMe',
    'decommission',
    'consult',
    'reassign',
    'conditionalCertifiy',
    'reject',
  ];

  if (!arr) {
    return [];
  }

  // Normalize API response format to match expected format
  const normalizedArr = arr.map((item) => {
    if (item === 'Belongs to Me') return 'belongsToMe';
    if (item === 'Decommission') return 'decommission';
    if (item === 'Does Not Belongs To Me') return 'doesNotWorksForMe';

    return item;
  });

  const bulkFooterBtnOrder = isEOCampaign ? eoBtnOrder : defaultBtnOrder;

  return [...normalizedArr].sort((a, b) => {
    const indexA = bulkFooterBtnOrder.indexOf(a);
    const indexB = bulkFooterBtnOrder.indexOf(b);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;

    return 0;
  });
};

// deep clone object
export const deepClone = (obj, visited = new WeakMap()) => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (obj instanceof Date) return new Date(obj);
  if (visited.has(obj)) return visited.get(obj);

  let cloned;

  if (obj instanceof Array) {
    cloned = [];
    visited.set(obj, cloned);
    cloned.push(...obj.map((item) => deepClone(item, visited)));
  } else {
    cloned = {};
    visited.set(obj, cloned);
    Object.entries(obj).forEach(([key, value]) => {
      cloned[key] = deepClone(value, visited);
    });
  }

  return cloned;
};

export default bulkFooterSortedBtns;
